//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.ShipDesign.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectDisplayableObject.js";
import "../Assemblies/Assemblies.SelectComponent.js";
import "../no/Section.js";
import "../no/Section.js";
import "../no/SelectObject.js";
let d=[[[1,"Component",0,"SelectDisplayableObject",0],[0,"ConfigFile",1,0],[0,"ExportDXFFile",1,0],[1,"ManufacturingCollector",0,"Assemblies.SelectComponent",0],[1,"MarkOnlySection",0,"Section",0],[0,"OutputFile",1,0],[0,"OutputType",1,0],[0,"ProfileXmlOutputFile",1,0]],[[["parts"],"SetParts",{},1,0]],[]];
SPLM.Features.ShipDesign.ManufacturingOutBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.ShipDesign.ManufacturingOutBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.ShipDesign.ManufacturingOutBuilder.OutputTypes = Object.freeze({
    "Plate" : "Plate", "Profile" : "Profile"});

export default SPLM;